import React from "react";
import { Pagination } from "@pd/pd-ui-kit";
import { Flex } from 'antd';
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import Wrapper from "~/shared/ui/Wrapper";
import { useGetIvideonLogs } from "~/entity/Logs";
import { useGetLocationData } from "~/hooks/locationData";
import { dateUTC } from "~/pages/Checklists/helper";
import { usePaginationParams } from "~/shared/hooks/usePaginationParams";
import { TableV2 } from "~/shared/ui/TableV2";

import ButtonsBlock from "./ButtonsBlock";
import IvideonLogsFilter from "./Filter";
import { formatDataForServer } from "./helper";
import { TABLE_IVIDEON_LOGS_OPTION } from "./options";

import styles from "./styles.less";

const IvideonLogs = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { page, count } = useGetLocationData();
  // Ключи фильтров приходят из URL и не описаны в типе useGetLocationData
  const { eventType, userId, startDate, endDate } =
    useGetLocationData() as Record<string, unknown>;

  const { handleCount, handlePage } = usePaginationParams();

  const dataFilter = formatDataForServer({
    eventType,
    userId,
    startDate,
    endDate,
  });

  const { data, isLoading } = useGetIvideonLogs({
    send: true,
    limit: count ? count : 25,
    page: page ?? 0,
    dataFilter,
  });

  const formattedItems = (data?.items ?? []).map((item) => ({
    ...item,
    createdAt: dateUTC(item.createdAt),
  }));

  const goBack = () => {
    history.replace("/logs/");
  };

  return (
    <Wrapper.Content
      additionalClassName={styles.ivideonLogsPage}
      title={t("logs.titleIvideon")}
      goBackHandler={goBack}
      txtBtn={t("ui.back")}
      filterComponent={<IvideonLogsFilter />}
    >
      <Flex justify={'flex-start'} className={styles.buttonsBlock}>
        <ButtonsBlock dataFilter={dataFilter} />
      </Flex>
      <TableV2
        wrapperClassName={styles.tableWrapper}
        options={TABLE_IVIDEON_LOGS_OPTION}
        dataSource={formattedItems}
        loading={isLoading}
        type="logs"
      />
      <Pagination
        count={count}
        page={page + 1}
        totalCount={data?.total}
        onChangeCount={handleCount}
        onChangePage={handlePage}
      />
    </Wrapper.Content>
  );
};

export default IvideonLogs;
